if (!customElements.get('variant-picker-compose')) {
  class VariantPickerCompose extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    init() {
      this.selectors = {
        error: '.g-product-form-message',
        variantIdInput: '[name="id"]',
        optionNodes: ['.g-product-option--node'],
      };
      this.domNodes = queryDomNodes(this.selectors, this);
      this.composeValue = this.getComposeByJson();

      const { productId, sectionId, productUrl, hasOnlyDefaultVariant, showFeaturedMedia } = this.dataset;

      this.productId = productId;
      this.sectionId = sectionId;
      this.productUrl = productUrl;
      this.hasOnlyDefaultVariant = hasOnlyDefaultVariant === 'true';
      this.showFeaturedMedia = showFeaturedMedia === 'true';
      this.initOptionSwatches();
    }
    getComposeByJson() {
      try {
        const composeValueElement = this.querySelector("#composeValue[type='application/json']");
        if (!composeValueElement) {
          throw new Error('Fallback product data element not found.');
        }
        return JSON.parse(composeValueElement.textContent);
      } catch (error) {
        console.error('Error loading fallback product data:', error);
        // Return a default value or further handle the error as needed
      }
    }
    initOptionSwatches() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.GkifySettings;
      if (this.domNodes.optionNodes) {
        this.domNodes.optionNodes.forEach((optNode) => {
          const { optionType, optionPosition, value: optionValue } = optNode.dataset;
          const optionValueLowerCase = optionValue && optionValue.toLowerCase();
          var variantImage = null;
          // const variantToShowSwatchImage = this.variantData.find((v) => v[`option${optionPosition}`] === optionValue);
          // const variantImage =
          //   variantToShowSwatchImage &&
          //   variantToShowSwatchImage.featured_image &&
          //   variantToShowSwatchImage.featured_image.src
          //     ? getSizedImageUrl(variantToShowSwatchImage.featured_image.src, '100x')
          //     : null;
          const customImage = _imageSwatches.find((i) => i.key === optionValueLowerCase);
          const customColor = _colorSwatches.find((c) => c.key === optionValueLowerCase);

          if (variantImage || (customImage && customImage.value)) {
            const labelElement = optNode.querySelector('label');
            if (labelElement) {
              labelElement.classList.add('has-bg-img');
            }
          }
          const labelElement = optNode.querySelector('label');
          if (labelElement) {
            labelElement.classList.remove('option-loading');

            switch (optionType) {
              case 'default':
              case 'image':
                labelElement.style.backgroundImage = `url(${(customImage && customImage.value) || variantImage || ''})`;
                break;
              case 'color':
                labelElement.style.background = (customColor && customColor.value) || optionValueLowerCase;
                if (customImage && customImage.value) {
                  labelElement.style.backgroundImage = `url(${customImage.value})`;
                }
                break;
              default:
                break;
            }
          }
        });
      }
    }
  }

  customElements.define('variant-picker-compose', VariantPickerCompose);
}
